import { createIntl, createIntlCache } from 'react-intl';
import { useLocaleStore } from '@/stores/localeStore';
import { defaultLocale, getLocaleOption } from './config';
import { getLocaleMessages } from './messages';

const intlCache = createIntlCache();

export function getIntl() {
  const locale = getLocaleOption(useLocaleStore.getState().locale).key;
  return createIntl(
    {
      locale,
      defaultLocale,
      messages: getLocaleMessages(locale),
    },
    intlCache,
  );
}
